import { useEffect } from "react";

/**
 * Bloquea el scroll del `<body>` mientras `locked` sea true.
 *
 * Uso: modales móviles. Sin esto, el scroll dentro de un modal (overflow-y-auto)
 * se propaga al body de fondo (scroll chaining) y la página de detrás se mueve.
 *
 * Restaura el valor PREVIO de `document.body.style.overflow` al desbloquear o
 * desmontar (NO hardcodea `""`), para no pisar un overflow que ya estuviera
 * fijado por otro motivo.
 */
export function useBodyScrollLock(locked: boolean): void {
  useEffect(() => {
    if (!locked) return;
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previous;
    };
  }, [locked]);
}
